export class TokenMalformedError implements Error {
  name = 'TokenMalformedError';

  constructor(
    public message: string,
    public stack?: string
  ) {}
}
